import React, { Component } from 'react';
import YoutubeSearcher from './YoutubeSearcher.js';
import DiscogsView from './DiscogsView.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {setYoutubeSearchTerms} from 'actions/index.js';
import { connect } from "react-redux";
import EthereumSoundsSearcher from 'search/EthereumSoundsSearcher.js';
import RecordLabelsView from './RecordLabelsView.js';
import EthereumCache from 'decentralized/cache/EthereumCache.js';
const ethereumCache = new EthereumCache();
const ethereumSearcher = new EthereumSoundsSearcher(ethereumCache);

const YOUTUBE = 'YOUTUBE';
const DISCOGS = 'DISCOGS';
const RECORD_LABELS = 'RECORD LABELS';
const SAMPLES = 'SAMPLES';

class InternetNavigatorPane extends Component {

    constructor(props) {
        super(props);

        this.state ={
            mode: YOUTUBE,
        };

        this.addListeners();

        this.sequencerEngine = {
            store: this.props.store,
        };
    }

    addListeners() {
        window.addEventListener('get_related_videos', () => {
            this.setState({
                mode: YOUTUBE
            });
        });
    }

    onClickOption(opt) {
        if (opt === DISCOGS) {
            window.dispatchEvent(new Event('get_record_labels'));
        }
        this.setState({mode: opt});
    }

    searchYoutube(searchString) {
        this.setState({
            mode: YOUTUBE
        });

        this.props.setYoutubeSearchTerms(searchString);
    }

    chooseSound(sample) {
        console.log('choose sample = ');
        console.log(sample);
        this.props.onClickResult(sample);
    }

    render() {
        let youtubeClass = this.state.mode === YOUTUBE ?
            "option-tab selected" : "option-tab";
        let discogsClass= this.state.mode === DISCOGS ?
            "option-tab selected" : "option-tab";
        let samplesClass = this.state.mode === SAMPLES ?
            "option-tab selected" : "option-tab";
        let recordLabelsClass = this.state.mode === RECORD_LABELS ?
            "option-tab selected" : "option-tab";

        let className = this.state.mode === SAMPLES ? 'internet-navigator show-sounds' : 'internet-navigator';
        return (
            <div className={className}>
              <div className="option-tabs">
                <div
                  onClick={() => this.onClickOption(YOUTUBE)}
                  className={youtubeClass}>
                  Youtube
                </div>
                <div
                  onClick={() => this.onClickOption(DISCOGS)}
                  className={discogsClass}>
                  Discogs
                </div>
                <div
                  onClick={() => this.onClickOption(RECORD_LABELS)}
                  className={recordLabelsClass}>
                  Record Labels
                </div>
              </div>
              <ConditionedComponent condition={this.state.mode===YOUTUBE}>
                <YoutubeSearcher videoId={this.props.videoId} onClickResult={this.props.onClickResult}/>
              </ConditionedComponent>
              <DiscogsView
                show={this.state.mode === DISCOGS}
                />
              <RecordLabelsView
                show={this.state.mode === RECORD_LABELS}
                searchYoutube={(s) => this.searchYoutube(s)}
                videoId={this.props.videoId}
                onClickResult={this.props.onClickResult}/>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setYoutubeSearchTerms: s => dispatch(setYoutubeSearchTerms(s)),
    };
};

const mapStateToProps = state => {
    return {
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(InternetNavigatorPane);
